import React from 'react';
import { useHistory } from 'react-router-dom';
import FranquiciasForm from './CatastrosForm';

const EditarCatastros = () => {
    const history = useHistory();
    return (
        <FranquiciasForm
            mode="EDIT"
            initialValues={history.location.state?.initialValues}
        />
    );
};

export default EditarCatastros;
